import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { QuestProvider } from '@questlabs/react-sdk';
import '@questlabs/react-sdk/dist/style.css';
import questConfig from './config/questConfig';
import Header from './components/Header';
import Footer from './components/Footer';
import AppHelp from './components/AppHelp';

// Pages
import Home from './pages/Home';
import AppointmentBooking from './pages/AppointmentBooking';
import AIChatbots from './pages/AIChatbots';
import CRMAutomation from './pages/CRMAutomation';
import DocumentGeneration from './pages/DocumentGeneration';
import MicrosoftAutomation from './pages/MicrosoftAutomation';
import WebsiteDesigning from './pages/WebsiteDesigning';
import OnlineForms from './pages/OnlineForms';
import ScanningOCR from './pages/ScanningOCR';
import CustomProcessAutomation from './pages/CustomProcessAutomation';
import './App.css';

function App() {
  return (
    <QuestProvider apiKey={questConfig.APIKEY} entityId={questConfig.ENTITYID} apiType="PRODUCTION">
      <Router>
        <div className="min-h-screen bg-white">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/appointment-booking" element={<AppointmentBooking />} />
            <Route path="/services/ai-chatbots" element={<AIChatbots />} />
            <Route path="/services/crm-automation" element={<CRMAutomation />} />
            <Route path="/services/document-generation" element={<DocumentGeneration />} />
            <Route path="/services/microsoft-automation" element={<MicrosoftAutomation />} />
            <Route path="/services/website-designing" element={<WebsiteDesigning />} />
            <Route path="/services/online-forms" element={<OnlineForms />} />
            <Route path="/services/scanning-ocr" element={<ScanningOCR />} />
            <Route path="/services/custom-process-automation" element={<CustomProcessAutomation />} />
          </Routes>
          <Footer />
          <AppHelp />
        </div>
      </Router>
    </QuestProvider>
  );
}

export default App;